import { CommApiInstance } from "Utils/CommApiInstance";

const MembNtfyMsgCtxtInqApi = async (
    msgSno:string|null
) => {
    return await CommApiInstance.post(`memb/ntfy_msg/${msgSno}`,{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
}
export default MembNtfyMsgCtxtInqApi;